import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IUrlsProcessingSummaryProps {
  datasetName: string;
  rejectedUrls: string[];
}

export const UrlsProcessingSummary = observer((props: IUrlsProcessingSummaryProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div>
      {t('upload_finished_with_rejected', { datasetName: props.datasetName })}
      <div>
        <ul>
          {props.rejectedUrls.map((u, i) => (
            <li key={i}>{u}</li>
          ))}
        </ul>
      </div>
    </div>
  );
});
